module.exports = __webpack_public_path__ + "img/grid-simulation.88819587.webp";